import memoize from 'lodash-es/memoize'
import { Group, Tween } from '@tweenjs/tween.js'

export { Tween, Easing, Group } from '@tweenjs/tween.js'

export type Animatable = Tween | Group

let animations: Animatable[] = []

export const addAnimation = (tween: Animatable) => {
  animations.push(tween)
  startAnimation()
}

const startAnimation = memoize(() => {
  requestAnimationFrame(animate)
})

function animate(time: number) {
  if (animations.length > 0) requestAnimationFrame(animate)
  else startAnimation?.cache?.clear?.()
  animations = animations.filter((tween) => {
    if (tween instanceof Group) {
      tween.update(time)
      return tween.allStopped()
    } else {
      return tween.update(time)
    }
  })
}
